module.exports = __webpack_public_path__ + "static/media/upload.65e0a0d1.svg";